<!-- <div *ngFor="let mn of menuItems; let i=index;trackBy:trackByIndex;">
    <div class="events-table-section" *ngIf="!mn.name.includes('In')">
        <app-sport-list *ngIf="tabId == mn.id && (!events.casino.includes(mn.id))" [list]="data" [eventId]="mn.id" [oddsData]="oddsLisDis"></app-sport-list>
    </div>
    <div class="events-table-section" *ngIf="mn.name.includes('In')">
        <app-sport-list *ngIf="tabId == mn.id && (!events.casino.includes(mn.id))" [list]="inPlayData" [eventId]="mn.id" [oddsData]="oddsLisDis"></app-sport-list>
    </div>
    <app-loader *ngIf="isLoad"></app-loader>
</div> -->

<div class="row">

    <div class="col-md-2 px-lg-1">
        <app-sidebar></app-sidebar>
    </div>
    <div class="col-md-10 col-12 px-1">
        <div class="center-section my-2">

          <!-- horse racing -->
          <div class="row" *ngIf="hRaceList.length > 0">
            <div class="col-lg-12">
              <h2 class="inner-title" data-bs-toggle="collapse" href="#HorseRacing" aria-expanded="true" aria-controls="HorseRacing">
                <span class="list-sport-title"><img class="img-fluid game-icon-img" src="http://speedcdn.io/assets/kesar-client/7.png"> Next Horse Racing</span>
              </h2>
              <div class="bet-table-body collapse show" id="HorseRacing">
                <div class="race-section">
                  <a href="javascript:void(0)" routerLink="/event/detail/{{item?.event_id}}/{{item?.market_id}}" class="chip" *ngFor="let item of hRaceList;trackBy:trackByIndex;">
                      <img src="https://flagcdn.com/h40/{{item?.event_country_code.toLowerCase()}}.png" alt="Horse" style="border-radius: 0px; width: 36px !important; height: 24px !important;" />
                      <div class="race_detail">
                          <span class="race_time" style="font-weight: 700;">
                            {{item?.market_start_time_format | date : 'hh:mm a'}}
                          </span>
                          <span class="race-name">{{item?.event_name}} - {{item?.market_name}}</span>
                      </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- horse racing -->

          <!-- greyhound racing -->
          <div class="row" *ngIf="gRaceList.length > 0">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body card-content p-0">
                  <h2 class="inner-title" data-bs-toggle="collapse" href="#GreyRacing" aria-expanded="true" aria-controls="GreyRacing">
                    <span class="list-sport-title"><img class="img-fluid game-icon-img" src="http://speedcdn.io/assets/kesar-client/4339.png"> Next Greyhound Racing</span>
                  </h2>
                  <div class="bet-table-body collapse show" id="GreyRacing">
                    <div class="race-section">
                      <a href="javascript:void(0)" routerLink="/event/detail/{{item?.event_id}}/{{item?.market_id}}" class="chip" *ngFor="let item of gRaceList;trackBy:trackByIndex;">
                          <img src="https://flagcdn.com/h40/{{item?.event_country_code.toLowerCase()}}.png" alt="Horse" style="border-radius: 0px; width: 36px !important; height: 24px !important;" />
                          <div class="race_detail">
                              <span class="race_time" style="font-weight: 700;">
                                {{item?.market_start_time_format | date : 'hh:mm a'}}
                              </span>
                              <span class="race-name">{{item?.event_name}} - {{item?.market_name}}</span>
                          </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- greyhound racing -->

          <tabset #staticTabs [class.nav-hidden]="id" type="fill innertabs nav-justified" id="myInnerTab">
            <tab *ngFor="let mn of menuItems; let i=index;trackBy:trackByIndex;" (selectTab)="onSelectStatic(i)">
              <ng-template tabHeading >
                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/{{mn.id == 'in_play' ? 'all' : mn.id}}.png">
                <span>{{mn.id == 'in_play' ? 'All' : mn.name}}</span>
              </ng-template>

              <h2 class="inner-title" >
                <!-- <img class="img-fluid" src="assets/images/icon/png/stop-watch-in-play.png"> -->
                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/{{mn.id == 'in_play' ? 'stop-watch-in-play' : mn.id}}.png">
                {{mn.id == 'in_play' ? 'IN-PLAY' : mn.name}}
              </h2>
              
              <!-- sports and races -->
              <div class="odds-even-sec" *ngIf="!events.casino.includes(mn.id) && mn.id != 'casino' && mn.id != 'others'">
                <!-- {{inPlayData | json}} -->
                <app-sport-list *ngIf="!events.casino.includes(mn.id)" [list]="mn.name.includes('In') ? inPlayData : data" [eventId]="mn.id" [oddsData]="oddsLisDis"></app-sport-list>
              </div>
              
              <!-- casino -->
              <app-casino *ngIf="tabId == mn.id && events.casino.includes(mn.id)" [casinoId]="mn.id"></app-casino>

              <div *ngIf="mn.id == 'casino'">
                <div class="row mx-0 other_tab">
                  <div class="col-md-6 col-12 px-1" *ngFor="let item of casinoMenu;trackBy:trackByIndex;">
                    <a href="javascript:void(0);" routerLink="/exchange_sports/{{item.id}}">
                      <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/{{item.id}}.png"/>
                      <p>{{item.name}}</p>
                    </a>
                  </div> 
                </div>
              </div>

              <!-- OTHERS -->
              <div *ngIf="mn.id == 'others'">
                <div class="row mx-0 other_tab">
                  <div class="col-md-6 col-12 px-1" *ngFor="let item of otherMenu;trackBy:trackByIndex;">
                    <a href="javascript:void(0);" routerLink="/exchange_sports/{{item.id}}">
                      <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/{{item.id}}.png"/>
                      <p>{{item.name}}</p>
                    </a>
                  </div>
                </div>
              </div>
              
            </tab>
          </tabset>

        </div>
        <app-loader *ngIf="isLoad"></app-loader>
    </div>
    <!-- <div class="col-md-3 px-1 d-none d-sm-block">
      <div class="betting-section">
          <nav class="nav-justified">
            <div class="nav nav-tabs bms-tabs" id="nav-tab" role="tablist">
              <a class="nav-item nav-link active" id="nav-Betslip-tab" data-toggle="tab" href="#nav-Betslip" role="tab" aria-controls="nav-Betslip" aria-selected="true">Betslip</a>
              <a class="nav-item nav-link" id="nav-MyBets-tab" data-toggle="tab" href="#nav-MyBets" role="tab" aria-controls="nav-MyBets" aria-selected="false">MyBets</a>
              <a class="nav-item nav-link" id="nav-Stakes-tab" data-toggle="tab" href="#nav-Stakes" role="tab" aria-controls="nav-Stakes" aria-selected="false">Stakes</a>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-Betslip" role="tabpanel" aria-labelledby="nav-Betslip-tab">
              <app-bet-slip></app-bet-slip>
            </div>
            <div class="tab-pane fade" id="nav-MyBets" role="tabpanel" aria-labelledby="nav-MyBets-tab">
              <app-bet-list *ngIf="isLogin();"></app-bet-list>
            </div>
            <div class="tab-pane fade" id="nav-Stakes" role="tabpanel" aria-labelledby="nav-Stakes-tab">
              <app-stake *ngIf="isLogin();"></app-stake>
            </div>
          </div>
        </div>  
    </div> -->
</div>